import { connect } from "react-redux";

import { selectBreadcrumbs } from "../selectors";
import { Breadcrumbs } from "@authzsvc/common-react-components";

export default connect((state) => ({
  nav: selectBreadcrumbs(state),
}))(Breadcrumbs);
